import { render, staticRenderFns } from "./recipeFooterAttributes.vue?vue&type=template&id=501e0b02&"
import script from "./recipeFooterAttributes.vue?vue&type=script&lang=js&"
export * from "./recipeFooterAttributes.vue?vue&type=script&lang=js&"
import style0 from "./recipeFooterAttributes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports